import { Card, CardContent, CardHeader, Checkbox } from "@mui/material";
import PropTypes from "prop-types";

const ClickableCard = ({ checkbox_id, children, style, onChangeAction, isSelected, hideCheckbox }) => {
  const sx = {
    display: "flex",
    justifyContent: "flex-start",
    gap: 0,
    backgroundColor: isSelected ? "#D2FFD4" : "#fff",
  };

  return (
    <Card
      variant="outlined"
      style={style}
      sx={sx}
    >
      <CardHeader action={
      !hideCheckbox && (<Checkbox id={checkbox_id} onChange={onChangeAction} />)
  }
/>
      <CardContent sx={{ padding: 4 }}>
        {children}
      </CardContent>
    </Card>
  );
};

ClickableCard.propTypes = {
  hideCheckbox: PropTypes.bool,
};

export default ClickableCard;